import { useDroppable } from "@dnd-kit/core";
import { Header } from "@tanstack/react-table";
import classNames from "classnames";
import { useCallback } from "react";

import { useTableContext } from "../context";
import TableColumnHeader from "./cell";

export default function TableColumnHeaderWrapper({
  header,
}: {
  header: Header<unknown, unknown>;
}) {
  const { setNodeRef } = useDroppable({
    id: header.id,
  });
  const { columnWidths, onColumnResize } = useTableContext();
  const width = columnWidths[header.id];

  const handlePointerDown = useCallback(
    (e: React.PointerEvent) => {
      e.preventDefault();
      e.stopPropagation();
      let prevX = e.clientX;

      const onPointerMove = (ev: PointerEvent) => {
        const delta = ev.clientX - prevX;
        prevX = ev.clientX;
        onColumnResize(header.id, delta);
      };

      const onPointerUp = () => {
        document.removeEventListener("pointermove", onPointerMove);
        document.removeEventListener("pointerup", onPointerUp);
      };

      document.addEventListener("pointermove", onPointerMove);
      document.addEventListener("pointerup", onPointerUp);
    },
    [header.id, onColumnResize],
  );

  return (
    <th
      id={header.id}
      ref={setNodeRef}
      className={classNames(
        "py-2 px-4 whitespace-nowrap text-ellipsis overflow-hidden relative border-r border-white last:border-r-0",
      )}
      align="left"
      style={{ width }}
    >
      <TableColumnHeader key={header.id} header={header} />
      <div
        onPointerDown={handlePointerDown}
        className="absolute top-0 -right-1 h-full w-2 cursor-col-resize group z-10"
      >
        <div className="absolute top-0 right-1 h-full w-0.5 group-hover:bg-primary-300 group-active:bg-primary-400 transition-colors" />
      </div>
    </th>
  );
}
